import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { Controller } from "react-hook-form";
import CustomSelect from "../../../../../common/input/custom-select/custom-select";
import styles from "./ranking-position-fields.module.css";
import { fetchExamTypes, fetchInstituteExams } from "../../../../../services/student_promotion";

const RankingPositionFields = ({ control, watch, setLoading }) => {
  const [examTypes, setExamTypes] = useState([]);
  const [examList, setExamList] = useState([]);
  const examTypeId = watch("exam_type_id");

  useEffect(() => {
    getExamTypes();
  }, []);

  useEffect(() => {
     examTypeId && getInstitutionExams();
  }, [examTypeId]);

  const getExamTypes = async () => {
    try {
      setLoading(true);
      const response = await fetchExamTypes();
      if (response?.data) {
        setExamTypes(response?.data?.data);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const getInstitutionExams = async () => {
    try {
      setLoading(true);
      const payload = { exam_type_id: examTypeId };
      const response = await fetchInstituteExams(payload);
      if (response?.data) {
        setExamList(response?.data?.data);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setExamList([]);
      setLoading(false);
    }
  };

  return (
    <div className={styles.rankingInputContainer}>
      <Controller
        name="exam_type_id"
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomSelect
            id="exam_type_id"
            label="Select Exam Type"
            showRequired
            labelColor="#667085"
            placeholder="--Select--"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          >
            {examTypes?.map((option) => (
              <Select.Option
                key={option?.id}
                value={option?.id}
              >
                {option?.term}
              </Select.Option>
            ))}
          </CustomSelect>
        )}
      />
      <Controller
        name="exam_id"
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomSelect
            id="exam_id"
            label="Select Exam"
            showRequired
            labelColor="#667085"
            placeholder="--Select--"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          >
            {examList?.map((option) => (
              <Select.Option
                key={option?.id}
                value={option?.id}
              >
                {option?.exam_name}
              </Select.Option>
            ))}
          </CustomSelect>
        )}
      />
    </div>
  );
};

export default RankingPositionFields;